
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_f8g6q_1rj01_94"
};
  